import Cookies from 'js-cookie';
import { ISMResponse } from '../models';

function request(
    route: string,
    options: RequestInit,
    url: 'api' | 'cdn' = 'api',
    isForm = false,
): Promise<Response> {
    if (!options.headers) options.headers = {};
    if (options.body && (options.headers as any)['type'] !== 'multipart/form-data' && !isForm)
        options.headers = {
            'Content-Type': 'application/json',
            ...options.headers,
        };

    const auth = Cookies.get('sm_auth');

    if (auth) options.headers = { Authorization: auth, ...options.headers };

    return fetch(
        `${url === 'api' ? process.env.REACT_APP_API_URL : process.env.REACT_APP_CDN_URL}/${route}`,
        options,
    );
}

export default {
    get: async (route: string, options?: RequestInit) => {
        return request(route, { ...options, method: 'GET' });
    },
    post: async (route: string, options?: RequestInit) => {
        return request(route, { ...options, method: 'POST' });
    },
    delete: async (route: string, options?: RequestInit) => {
        return request(route, { ...options, method: 'DELETE' });
    },
    search: async (route: string, options?: RequestInit) => {
        return request(route, { ...options, method: 'SEARCH' });
    },
    patch: async (route: string, options?: RequestInit) => {
        return request(route, { ...options, method: 'PATCH' });
    },
    cdnGet: async (route: string, options?: RequestInit) => {
        return request(route, { ...options, method: 'GET' }, 'cdn');
    },
    cdnPost: async (route: string, options?: RequestInit) => {
        return request(route, { ...options, method: 'POST' }, 'cdn', true);
    },
};

export async function retrieveApiErrorCode(response: Response) {
    if (response.ok && response.status === 500) {
        return false;
    }
    const content = (await response.json()) as ISMResponse<{
        code: number;
        message: string;
        errors: { code: number; message: string }[];
    }>;
    return content.data.errors[0].code;
}
